import { useState } from "react"
import { Link } from "react-router-dom"
import KravMagaSantos from "../images/KravMagaSantos.svg"
import { useAuth } from "../auth/AuthContext"
import ForgotPasswordModal from "./ForgotPasswordModal"

export default function LoginForm() {
  const { login } = useAuth()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [role, setRole] = useState("student")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [showForgotPassword, setShowForgotPassword] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError("")
    try {
      setLoading(true)
      await login({ email, password, role })
    } catch (err) {
      setError(err?.message || "Falha no login.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit} className="w-full h-dvh">
        <h1 className="text-5xl text-center font-oswald font-semibold text-gray-50 lg:text-cor-base mb-4 pt-6 drop-shadow-lg">
          Área do {role === "professor" ? "professor" : "aluno"}
        </h1>

        <div className="bg-slate-50 rounded-3xl py-6 px-4 mr-16 ml-16 lg:bg-[#abb2b9] drop-shadow-xl">
          <div className="flex justify-center mb-6">
            <div className="h-52 w-48 mb-6">
              <img
                src={KravMagaSantos}
                alt="Krav Maga Logo"
                className="object-contain drop-shadow-lg"
              />
            </div>
          </div>

          <h2 className="text-4xl font-semibold text-cor-base drop-shadow-lg">
            Bem-vindo(a) de volta!
          </h2>
          <p className="text-lg mt-1 text-cor-base drop-shadow-lg">
            Por favor, preencha com seus dados de cadastro.
          </p>

          <div className="mt-4 mb-2 text-cor-base drop-shadow-lg">
            <label className="text-lg font-medium">Perfil</label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="w-full border-2 border-gray-200 rounded-xl text-center p-2 mt-1 bg-transparent"
              aria-label="Selecionar perfil">
              <option value="student">Aluno</option>
              <option value="professor">Professor</option>
            </select>
          </div>

          <div className="mt-4 mb-2 text-cor-base drop-shadow-lg">
            <label className="text-lg font-medium">Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-2 border-gray-200 rounded-xl text-center p-2 mt-1 bg-transparent placeholder:text-gray-400"
              placeholder="Insira seu e-mail"
              type="email"
              autoComplete="email"
              required
            />
          </div>

          <div className="mt-4 mb-2 text-cor-base drop-shadow-lg">
            <label className="text-lg font-medium">Senha</label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-2 border-gray-200 rounded-xl text-center p-2 mt-1 bg-transparent placeholder:text-gray-400"
              placeholder="Insira sua senha"
              type="password"
              autoComplete="current-password"
              required
            />
          </div>

          <div className="mb-2 text-right text-cor-base drop-shadow-lg">
            <button
              type="button"
              onClick={() => setShowForgotPassword(true)}
              className="text-sm hover:underline">
              Esqueci minha senha
            </button>
          </div>

          {error ? (
            <p className="text-red-700 text-center mt-3 font-semibold">
              {error}
            </p>
          ) : null}

          <button
            disabled={loading}
            className="mt-4 ease-in-out drop-shadow-lg w-full py-3 text-2xl bg-cor-base text-white rounded-xl active:scale-[.96] active:duration-75 transition-all hover:scale-[1.01] disabled:opacity-60 disabled:cursor-not-allowed"
            type="submit">
            {loading ? "Entrando..." : "Entrar"}
          </button>

          <div className="text-right lg:hidden">
            <p className="text-cor-base text-lg pt-6">
              Ainda não se cadastrou?
            </p>
            <Link
              to="/cadastro"
              className="text-cor-base text-lg font-semibold hover:underline">
              Registre-se aqui!
            </Link>
          </div>
        </div>
      </form>

      {showForgotPassword && (
        <ForgotPasswordModal onClose={() => setShowForgotPassword(false)} />
      )}
    </>
  )
}
